// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__IaZeG","title":"BackImages_title__2Qmdg","images":"BackImages_images__qv6Hj"};